<template>
  <div class="dwgwHeader">
    <div class="headerContent">
      <img :src="logo" alt="" class="logo" />
      <ul>
        <li v-for="item in ullist" :key="item.id" :class="classObject(item.id)" @click="changeShow(item.id)">
          {{ item.title }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import { mapActions } from "vuex";

export default {
  name: "dwgwHeader",
  computed: {
    ...mapState(["showSet"]),
  },
  methods:{
    ...mapActions(["changeShowsetAction"]),
    classObject(id) {
      return id == this.showSet ? "showBottom" : "";
    },
    changeShow(id){
      this.changeShowsetAction(id)
    }
  },
  data() {
    return {
      logo: require("./jpg/dp_logo.png"),
      ullist: [
        {
          id: "dwgwsy",
          title: "首页",
        },
        {
          id: "dwgwabout",
          title: "关于蝶威",
        },
        {
          id: "dwgwcp",
          title: "蝶威产品",
        },
        {
          id: "dwgwjoin",
          title: "加入蝶威",
        },
        {
          id: "dwgwgg",
          title: "蝶威公告",
        },
        {
          id: "dwgwteam",
          title: "蝶威文化",
        },
        {
          id: "dwgwlxwm",
          title: "联系我们",
        },
      ],
    };
  },
};
</script>

<style scoped>
.headerContent {
  height: 75px;
  background: white;
  padding-top: 25px;
  font-size: 15px;
  padding-right: 10%;
  padding-left: 10%;
  box-shadow: 0 0 6px 3px rgba(117, 102, 65, 0.1);
  z-index: 99999;
}
.logo {
  display: block;
  float: left;
  width: 185px;
}

ul {
  float: right;
  height: 100%;
}
li {
  float: left;
  list-style: none;
  padding: 0 14px;
  height: 100%;
  line-height: 64px;
  cursor: pointer;
}

.showBottom{
  border-bottom: 2px solid #c8ad6d;
  color: #c8ad6d;
}
</style>


// WEBPACK FOOTER //
// src/components/dwgwmainHeader.vue